import { inject, Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { WdxErrorModalComponent } from '@wdx/shared/components/wdx-error-modal';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ErrorRule } from '@wdx/clmi/api-services/services';
import { SystemSettingsService } from '@wdx/clmi/utils/services';

@Injectable()
export class Http500ErrorInterceptor implements HttpInterceptor {
    private modalService = inject(NgbModal);
    private systemSettingsService = inject(SystemSettingsService);

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                const settings =
                    this.systemSettingsService.get()?.ErrorHandling;

                if (!settings) {
                    throw error;
                }

                const { rules, showErrorPopup, showErrorDetails } = settings;

                if (!showErrorPopup) {
                    throw error;
                }

                const method = req.method;
                const statusCode = error.status;
                const errorMessage = error.message;

                const matchingRule = rules.find((rule) =>
                    this.isRuleMatching(rule, method, statusCode, errorMessage),
                );

                if (matchingRule) {
                    this.showModal(matchingRule, showErrorDetails, error);
                }

                throw error;
            }),
        );
    }

    private isRuleMatching(
        rule: ErrorRule,
        method: string,
        statusCode: number,
        errorMessage: string,
    ): boolean {
        return (
            (!rule.methods || rule.methods.includes(method)) &&
            (!rule.codePattern ||
                new RegExp(rule.codePattern).test(String(statusCode))) &&
            (!rule.messagePattern ||
                new RegExp(rule.messagePattern).test(errorMessage))
        );
    }

    private showModal(
        matchingRule: ErrorRule,
        showErrorDetails: boolean,
        error: HttpErrorResponse,
    ): void {
        const MODAL_CONFIG: NgbModalOptions = {
            backdropClass: 'modal-backdrop--ngb',
            windowClass: 'modal-window--ngb',
            centered: true,
            modalDialogClass: 'modal-dialog-centred-xs',
        };

        const modalRef = this.modalService.open(
            WdxErrorModalComponent,
            MODAL_CONFIG,
        );

        modalRef.componentInstance.title = matchingRule.title;
        modalRef.componentInstance.description = matchingRule.description;
        modalRef.componentInstance.showErrorDetails = showErrorDetails;
        modalRef.componentInstance.modalOptions = MODAL_CONFIG;

        if (showErrorDetails) {
            modalRef.componentInstance.jsonData = error;
        }
    }
}
